import { useEffect, useState } from "react";
import styled from "styled-components";
import { Button } from "styles/Styles.styled";

interface ResendTimerButtonProps {
  cooldownEndTime: number | null;
  onResend: () => void;
}

const ResendTimerButton: React.FC<ResendTimerButtonProps> = ({ cooldownEndTime, onResend }) => {
  const [secondsRemaining, setSecondsRemaining] = useState(0);

  useEffect(() => {
    if (!cooldownEndTime) {
      setSecondsRemaining(0);
      return;
    }

    let intervalId: NodeJS.Timeout;

    const updateTimer = () => {
      const now = Date.now();
      const timeLeft = Math.ceil((cooldownEndTime - now) / 1000);

      if (timeLeft <= 0) {
        setSecondsRemaining(0);
        if (intervalId) clearInterval(intervalId);
      } else {
        setSecondsRemaining(timeLeft);
      }
    };

    updateTimer();

    if (cooldownEndTime > Date.now()) {
      intervalId = setInterval(updateTimer, 1000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [cooldownEndTime]);

  if (secondsRemaining > 0) {
    return (
      <span style={{ color: 'rgba(117, 117, 117, 1)' }}>
        Click to resend in 0:{secondsRemaining.toString().padStart(2, '0')}
      </span>
    );
  }

  return <ActionButton onClick={onResend}>Click to resend</ActionButton>;
};

export default ResendTimerButton;

const ActionButton = styled(Button).attrs({ text: true })`
  color: ${(props) => props.theme.colors.primaryOrange};
  font-size: 0.875rem;
  font-family: inherit;
  line-height: 1.3rem;
  font-weight: 400;
  padding: 0;
  border: none;
  border-radius: 2px;
  background-color: transparent;
  &:hover {
    background-color: transparent;
  }
  &&:focus-visible {
    outline: 2px solid #000000;
  }
`;